import { defineFcm } from '../shared/factory';

export const FCM_SIGNATURE_GROWTH_GOOGLE_ONE_TAP_LOGIN_CONFIG = defineFcm(
	'signature_growth_google_one_tap_login_config',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Enable Google’s One-Tap Login',
		description: 'Set true to enable Google’s One-Tap Login FC should be enabled by individual Locales',
		import: false,
	});
